import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, X } from "lucide-react";
import { BRAND } from "@/data/brand";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (dismissed) return;
    if (location.pathname.startsWith("/free-claim-evaluation")) return;
    const onScroll = () => {
      const pct = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      setVisible(pct > 0.3);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [dismissed, location.pathname]);

  if (!visible || dismissed) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 hidden md:flex items-center gap-3 glass-strong px-5 py-3"
      style={{ boxShadow: "0 30px 60px -20px rgba(0,0,0,0.7), 0 0 40px rgba(0,119,255,0.15)" }}
      data-testid="sticky-cta-bar"
    >
      <span className="font-mono text-[0.65rem] text-ag-text-muted tracking-[0.22em] uppercase">No recovery · No fee</span>
      <span className="h-4 w-px bg-white/10" />
      <Link to="/free-claim-evaluation" data-testid="sticky-cta-evaluation" className="btn-gold !py-2.5 !px-5 !text-[0.65rem]">
        Free Evaluation
      </Link>
      <a href={BRAND.phoneHref} data-testid="sticky-cta-call" className="btn-ghost-blue !py-2.5 !px-4 !text-[0.65rem] flex items-center gap-1.5">
        <Phone className="w-3 h-3" /> Call
      </a>
      <button
        aria-label="Dismiss"
        data-testid="sticky-cta-dismiss"
        onClick={() => setDismissed(true)}
        className="text-white/40 hover:text-white/80 ml-1 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
